import React from 'react';
import { defaultStrings } from 'js/config/config';

export class IconFooter extends React.Component {
  render() {
    const copyrightText = `${new Date().getFullYear()} American Society of Civil Engineers. All rights reserved, including rights for text and data mining and training of artificial technologies or similar technologies.`;

    return (
      <div className='left-panel-footer flex flex-column'>
        <div className='grey-text text-lighten-5'>{defaultStrings.disclaimerText}</div>
        <div className='flex flex-row flex-justify-between align-items-center'>
          <a href={defaultStrings.asceSite} target='_blank' className={'brand-logo-container'} />
          <a
            href={defaultStrings.aboutPage}
            target='_blank'
            title={defaultStrings.aboutInfo}
            className={'question-icon'}
          />
          <a href={defaultStrings.termsPage} target='_blank' title={defaultStrings.termsInfo} className={'file-icon'} />
          <a
            href={defaultStrings.asceMail}
            target='_blank'
            title={defaultStrings.contactInfo}
            className={'email-icon'}
          />
        </div>
        <div className='grey-text text-lighten-5'>&copy; {copyrightText}</div>
        <a href='https://amplify.asce.org/api/' target='_blank' className='advertisement'>
          <img src='app/images/asce-hazard-tool-api-advertisement.jpg' />
        </a>
      </div>
    );
  }
}
